import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const BranchCreateModal = lazy(() => import('.'))

class BranchCreateModalComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['project-id', 'opened']
  }

  override render() {
    const projectId = this.prop('project-id')
    const opened = this.prop('opened') === 'true'

    return (
      <RootProviders>
        {opened && (
          <BranchCreateModal
            projectId={projectId}
            opened={opened}
            onClose={() => {
              this.dispatchEvent(new Event('close'))
            }}
            onBranchCreated={(branchName) => {
              this.dispatchEvent(new CustomEvent('branchcreated', { detail: branchName }))
            }}
          />
        )}
      </RootProviders>
    )
  }
}

customElements.define('branch-create-modal', BranchCreateModalComponent)
